export default function initDropdowns(): void {
    const $dropdownsContainer = document.querySelectorAll<HTMLElement>('.js-dropdowns-container');

    $dropdownsContainer.forEach($container => {
        new Dropdowns($container);
    });
}

class Dropdowns {
    $el: HTMLElement | null | undefined;

    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.init();
    }

    init(): void {
        if (this.$el) {
            this.expandHandler();
        }
    }

    expandHandler(): void {
        const expands = this.$el?.querySelectorAll('.js-dropdowns');
        expands?.forEach((expand) => {
            const firstExpand = expand.querySelector('.dropdown') as HTMLDetailsElement;
            firstExpand.open = true;
        })


    }
}
